import { CommandInterface } from '../interfaces/command.interface';

export const DEFAULT_COMMANDS: CommandInterface[] = [
  // Vendas
  {
    id: 'new-sale',
    label: 'Nova Venda',
    category: 'Vendas',
    icon: 'plus',
    route: '/vendas',
    keywords: ['vender', 'pedido', 'criar venda'],
    shortcut: 'F2'
  },
  {
    id: 'list-sales',
    label: 'Listar Vendas',
    category: 'Vendas',
    icon: 'list',
    route: '/vendas/historico'
  },
  // Clientes
  {
    id: 'new-customer',
    label: 'Novo Cliente',
    category: 'Clientes',
    icon: 'user-plus',
    route: '/clientes/novo',
    keywords: ['cadastrar cliente', 'adicionar pessoa'],
    shortcut: 'Alt + C',
    keys: 'alt.c'
  },
  {
    id: 'list-customers',
    label: 'Listar Clientes',
    category: 'Clientes',
    icon: 'users',
    route: '/clientes'
  },
  // Produtos
  {
    id: 'new-product',
    label: 'Novo Produto',
    category: 'Produtos',
    icon: 'package-plus',
    route: '/produtos/novo',
    keywords: ['cadastrar produto', 'adicionar item', 'estoque'],
    shortcut: 'Alt + P',
    keys: 'alt.p'
  },
  {
    id: 'list-products',
    label: 'Listar Produtos',
    category: 'Produtos',
    icon: 'package',
    route: '/produtos'
  },
  {
    id: 'manage-brands',
    label: 'Gerenciar Marcas',
    category: 'Produtos',
    icon: 'tag',
    route: '/marcas'
  },
  // Financeiro
  {
    id: 'financial-dashboard',
    label: 'Painel Financeiro',
    category: 'Financeiro',
    icon: 'dollar-sign',
    route: '/financeiro'
  },
  {
    id: 'financial-payable',
    label: 'Contas a Pagar',
    category: 'Financeiro',
    icon: 'arrow-down-circle',
    route: '/financeiro/pagar'
  },
  {
    id: 'financial-receivable',
    label: 'Contas a Receber',
    category: 'Financeiro',
    icon: 'arrow-up-circle',
    route: '/financeiro/receber'
  },
  // Geral
  {
    id: 'dashboard',
    label: 'Dashboard',
    category: 'Geral',
    icon: 'layout-dashboard',
    route: '/dashboard',
    keywords: ['home', 'inicio', 'visão geral']
  },
  {
    id: 'profile',
    label: 'Meu Perfil',
    category: 'Geral',
    icon: 'user',
    route: '/perfil',
    keywords: ['conta', 'dados', 'configurações']
  },
  {
    id: 'notifications',
    label: 'Notificações',
    category: 'Geral',
    icon: 'bell',
    route: '/notifications'
  },
  {
    id: 'list-users',
    label: 'Listar Usuários',
    category: 'Sistema',
    icon: 'users',
    route: '/usuarios',
    keywords: ['equipe', 'colaboradores', 'acessos']
  },
  {
    id: 'create-user',
    label: 'Criar Usuário',
    category: 'Sistema',
    icon: 'user-plus',
    route: '/usuarios/criar',
    keywords: ['novo usuário', 'cadastrar acesso', 'convidar usuário']
  },
  {
    id: 'manage-access-profiles',
    label: 'Perfis de acesso',
    category: 'Sistema',
    icon: 'badge-check',
    route: '/perfis-de-acesso',
    keywords: ['perfil', 'função', 'cargo', 'vendedor de balcão', 'acessos']
  },
  {
    id: 'manage-permissions',
    label: 'Gerenciar Permissões',
    category: 'Sistema',
    icon: 'shield',
    route: '/permissoes',
    keywords: ['acessos', 'roles', 'autorizações']
  }
];
